import { NgModule } from "@angular/core";
import { PopupSearchComponent } from './Controls/popup-search/popup-search';
import { ReminderControlComponent } from './Controls/Reminder/reminder-control';
import { CommonModule } from "@angular/common";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { BrowserModule } from '@angular/platform-browser';
import { MatSelectModule } from "@angular/material/select";
@NgModule({
  declarations: [
    PopupSearchComponent,
    ReminderControlComponent
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    //BrowserModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSelectModule
  ],
  exports: [
    PopupSearchComponent,
    ReminderControlComponent
  ],
  entryComponents: [PopupSearchComponent, ReminderControlComponent],
  bootstrap: [PopupSearchComponent, ReminderControlComponent]
})
export class CommonControlsModule { }
